// extracted by mini-css-extract-plugin
export var errorsContainer = "_ri-1";
export var link = "_ri-0";